<app-card
  [tone]="tone()"
  [badge]="badge()"
  [portalUrl]="portalUrl()"
  [staleAge]="stale() ? age() : null"
>
  <div card-title>
    <h2>{{ entity().name }}</h2>
    <p class="where">
      <span class="kind">{{ entity().kind }}</span>
      <span class="namespace">{{ entity().namespace }}</span>
    </p>
  </div>

  @if (readable()) {
    @if (notActive(); as state) {
      <p class="notice">
        This {{ entity().kind.toLowerCase() }} is <strong>{{ state }}</strong
        >, so messages may not be arriving or being taken from it.
      </p>
    }

    <dl class="stats">
      <div class="stat primary">
        <dt>
          Dead letters
          <app-info-tip [text]="deadLetterHelp" label="What are dead letters?" />
        </dt>
        <dd>{{ entity().deadLetterMessageCount | number }}</dd>
      </div>
      <div class="stat">
        <dt>Active</dt>
        <dd>{{ entity().activeMessageCount | number }}</dd>
      </div>
      <div class="stat">
        <dt>Scheduled</dt>
        <dd>{{ entity().scheduledMessageCount | number }}</dd>
      </div>
      <div class="stat">
        <dt>Size</dt>
        <dd>{{ size() }}</dd>
      </div>
    </dl>

    @if (entity().kind === 'Topic') {
      @if (entity().subscriptions.length === 0) {
        <p class="note">This topic has no subscriptions, so nothing can be dead-lettered.</p>
      } @else {
        <details class="subs" [open]="subscriptionsOpen()">
          <summary>
            {{ entity().subscriptions.length }}
            {{ entity().subscriptions.length === 1 ? 'subscription' : 'subscriptions' }}
            <app-info-tip [text]="topicHelp" label="Where do a topic's dead letters live?" />
          </summary>
          <ul class="sub-list" aria-label="Subscriptions of this topic">
            @for (subscription of entity().subscriptions; track subscription.name) {
              <li [class.dead]="subscription.deadLetterMessageCount > 0">
                <span class="sub-name">{{ subscription.name }}</span>
                <span class="sub-figures">
                  <strong>{{ subscription.deadLetterMessageCount | number }} dead</strong>
                  <span class="muted">{{ subscription.activeMessageCount | number }} active</span>
                </span>
              </li>
            }
          </ul>
        </details>
      }
    }
  } @else {
    <p class="message" role="alert">{{ entity().error }}</p>
  }

  <span card-meta class="checked">
    @if (lastAccessed(); as accessed) {
      <span [attr.title]="entity().accessedAt | date: 'medium'">Last read {{ accessed }}</span>
      ·
    }
    Checked {{ entity().checkedAt | date: 'mediumTime' }}
  </span>
</app-card>
